import { timelineItems } from '@/mocks/home';
import SectionHeading from '@/components/feature/SectionHeading';

const tagStyle: Record<string, string> = {
  起点: 'bg-secondary-100 text-secondary-900',
  关键: 'bg-primary-500 text-background-50',
  铺垫: 'bg-background-200 text-foreground-700',
  爆发: 'bg-primary-500 text-background-50',
  回应: 'bg-accent-100 text-accent-900',
  最新: 'bg-accent-500 text-foreground-950',
};

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="FULL TIMELINE"
          title="事件全梳理 · 一条线看完"
          desc="把公开信息按时间顺序排好，谁先动、谁后应、哪里出现空窗，一眼就能对上。"
          actionHref="#ranking"
          actionLabel="看热榜实时排名"
        />

        <div className="relative">
          <span className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300" />
          <ol className="space-y-6 md:space-y-7">
            {timelineItems.map((item) => (
              <li key={item.time} className="relative pl-8 md:pl-10">
                <span className="absolute left-0 top-1.5 w-4 h-4 md:w-[18px] md:h-[18px] rounded-full bg-background-50 border-2 border-primary-500 flex items-center justify-center">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
                </span>
                <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-5">
                  <div className="md:w-40 shrink-0 flex items-center gap-3">
                    <span className="font-heading font-semibold text-sm md:text-base text-foreground-950 tabular-nums">
                      {item.time}
                    </span>
                  </div>
                  <div className="flex-1 rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
                    <div className="flex items-center gap-2.5 flex-wrap">
                      <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                        {item.title}
                      </h3>
                      <span
                        className={`px-2 py-0.5 rounded text-[11px] font-medium ${tagStyle[item.tag] ?? 'bg-background-200 text-foreground-700'}`}
                      >
                        {item.tag}
                      </span>
                    </div>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <span className="text-sm text-foreground-500">相关专题：</span>
          {['深夜录音事件', '结算单之谜', '时间戳断点', '工作室注销'].map((t) => (
            <a
              key={t}
              href="#archive"
              className="px-3.5 py-2 rounded-full text-sm bg-background-50 border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              #{t}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}